import Model from './BaseModel'
import i18n from '@/plugins/i18n'

export default class Setting extends Model {
    resourceName() {
        return 'emails'
    }

    fields() {
        return ['id', 'title', 'payload', 'active', 'to']
    }

    computed() {
        return {
            isActive(email) {
                return email.active ? 'Ativo' : 'Inativo'
            },
        }
    }

    get tableColumns() {
        return [
            { text: i18n.t('email.table-texts.title'), value: 'title' },
            { text: i18n.t('email.table-texts.active'), value: 'isActive' },
            {
                text: i18n.t('email.table-texts.actions'),
                value: 'action',
                sortable: false,
            },
        ]
    }

    get searchable() {
        return ['title']
    }

    constructor() {
        super()

        if (!this.payload) {
            this.payload = {
                from: '',
                host: '',
                port: '',
                username: '',
                password: '',
                encryption: '',
            }
        }
    }
}
